import { useCallback, useRef, useState } from 'react';

type ScrollState = {
    canScrollLeft: boolean;
    canScrollRight: boolean;
};

export default function useHorizontalScroll(scrollAmount = 500) {
    const scrollRef = useRef<HTMLDivElement>(null);
    const [scrollState, setScrollState] = useState<ScrollState>({ canScrollLeft: false, canScrollRight: false });

    const updateScrollState = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        setScrollState({
            canScrollLeft: el.scrollLeft > 0,
            canScrollRight: el.scrollLeft + el.clientWidth < el.scrollWidth - 1,
        });
    }, []);

    const handleScroll = useCallback(
        (dir: 'left' | 'right') => {
            const el = scrollRef.current;
            if (!el) return;
            el.scrollBy({ left: dir === 'right' ? scrollAmount : -scrollAmount });
        },
        [scrollAmount]
    );

    return {
        scrollRef,
        scrollState,
        updateScrollState,
        handleScroll,
    };
}
